//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// other stuff
import { asCard } from "@components/card";
// event imports
import { cardContent, cardHeader, cardBody } from "./Event.styles";
// state
import { IReduxState } from "@reducers/root.reducer";

//////////////////
// TYPES
//////////////////
interface IState {}
interface IContainer {}
interface IProps extends IContainer {
  removeCard?: () => void;
}

//////////////////
// COMPONENT
//////////////////
class UncrawledEventCmpt extends React.PureComponent<IProps, IState> {
  public render() {
    return (
      <div style={cardContent}>
        <div style={cardHeader}>Event Information Unavailable</div>
        <div style={cardBody}>This event is not crawled by Clockwise.</div>
      </div>
    );
  }
}

export const ShadowCalendarEventCard = asCard<{}>(UncrawledEventCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const UncrawledEvent = connect(mapStateToProps, {})(ShadowCalendarEventCard);
